import { memo } from 'react';
import { RouteMatch, matchRoutes, useLocation, useNavigate, useResolvedPath } from 'react-router-dom';
import { useFullReset } from '../../../../context/Kiosk/kiosk';
import { useLocalization } from '../../../../context/Localization/localization';
import { IconButton } from '../../../../controls/IconButton/IconButton';
import { GMSizedIcon } from '../../../../controls/Icon';
import { isElectron } from '../../../../helpers/EnvironmentFlags/EnvironmentFlags';
import css from '../Header.module.scss';
import type { BackIconProps } from './BackIcon.types';

export const BackIcon = memo(({ slim }: BackIconProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = useResolvedPath('.');
    const Localization = useLocalization();
    const resetKiosk = useFullReset();

    const disableBackRoutes: RouteMatch[] | null = matchRoutes(
        [
            {
                path: '/',
            },
            {
                path: `${pathname}/keydrop`,
            },
            {
                path: `${pathname}/survey1`,
            },
            {
                path: `${pathname}/survey2`,
            },
            {
                path: `${pathname}/advisor`,
            },
            {
                path: `${pathname}/locker`,
            },
            {
                path: `${pathname}/help`,
            },
            {
                path: `${pathname}/doublecheck`,
            },
            {
                path: `${pathname}/complete`,
            },
            {
                path: `${pathname}/keydrop/option`,
            },
            {
                path: `${pathname}/keydrop/advisor`,
            },
            {
                path: `${pathname}/keydrop/locker`,
            },
            {
                path: `${pathname}/keydrop/help`,
            },
            {
                path: `${pathname}/keydrop/doublecheck`,
            },
            {
                path: `${pathname}/keymanagement/keydrop`,
            },
            {
                path: `${pathname}/keymanagement/appointmentdetails/storekey/placekey`,
            },
            {
                path: `${pathname}/keymanagement/appointmentdetails/storekey/complete`,
            },
            {
                path: `${pathname}/keymanagement/storekey/placekey`,
            },
            {
                path: `${pathname}/keymanagement/storekey/complete`,
            },
        ],
        location,
    );

    const disableBackButton: boolean = !!disableBackRoutes && disableBackRoutes.length > 0;

    const makeBackResetRoutes: RouteMatch[] | null = matchRoutes(
        [
            {
                path: `${pathname}/keymanagement`,
            },
        ],
        location,
    );

    const makeBackReset: boolean = !!makeBackResetRoutes && makeBackResetRoutes.length > 0;

    return disableBackButton ? null : (
        <IconButton
            className={css.backIcon}
            headerIcon
            slim={slim}
            onClick={makeBackReset ? resetKiosk : () => navigate(-1)}
            sizedIcon={
                <GMSizedIcon
                    iconType={'Arrow-Back'}
                    iconSize={slim ? 'custom' : 'medium'}
                    ariaLabel={Localization.BackArrow}
                />
            }
            label={isElectron() ? undefined : Localization.Back}
            title={Localization.ClickToGoBack}
            ariaLabel={Localization.ClickToGoBack}
            id={Localization.ClickToGoBack}
        />
    );
});
